export default __webpack_public_path__ + "static/media/LinieGelb_desk.82203d94.svg";